import { Instant } from "@js-joda/core";
import * as SunCalc from "suncalc";
import { Geo } from "../../messages";

export function isOnDaylight(time: Instant, geo: Geo) {
  const times = SunCalc.getTimes(new Date(time.toEpochMilli()), geo.lat, geo.lng);
  const sunrise = Instant.ofEpochMilli(times.sunrise.getTime());
  const sunsetStart = Instant.ofEpochMilli(times.sunsetStart.getTime());
  const nauticalDawn = Instant.ofEpochMilli(times.nauticalDawn.getTime());

  return (time.isAfter(sunrise) || time.isAfter(nauticalDawn)) && time.isBefore(sunsetStart);
}
